
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 22 22"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 706","transform":"translate(-38 -435)"}},[_c('rect',{attrs:{"data-name":"Rectangle 2029","width":"22","height":"22","rx":"10","transform":"translate(38 435)","fill":"#7469d9"}}),_c('rect',{attrs:{"data-name":"Rectangle 2030","width":"16","height":"16","rx":"8","transform":"translate(41 438)","fill":"#4a4291"}}),_c('g',{attrs:{"data-name":"Rectangle 724","transform":"translate(46 443)","fill":"#42ddb3","stroke":"#42ddb3"}},[_c('rect',{attrs:{"width":"6","height":"6","rx":"3","stroke":"none"}}),_c('rect',{attrs:{"x":".5","y":".5","width":"5","height":"5","rx":"2.5","fill":"none"}})])])])
          )
        }
      }
    